<template>
  <div>
    <mds-fieldset
      :legend="translate('scheduler.modal.source.type.label')"
      class="scheduler-modal__fieldset"
      variation="radio-group"
      required
    >
      <mds-radio-button
        class="scheduler-modal__source-type"
        value="investment_list"
        :disabled="disableRadioButtons"
        :checked="sourceType === 'investment_list'"
        @input="$emit('source-type', $event)"
      >
        {{ translate('scheduler.modal.source.investment.list') }}
      </mds-radio-button>
      <mds-radio-button
        class="scheduler-modal__source-type"
        value="search_criteria"
        :disabled="disableRadioButtons"
        :checked="sourceType === 'search_criteria'"
        @input="$emit('source-type', $event)"
      >
        {{ translate('scheduler.modal.source.search.criteria') }}
      </mds-radio-button>
      <mds-radio-button
        v-if="showPerformanceReporting"
        class="scheduler-modal__source-type"
        value="performance_report"
        :disabled="disableRadioButtons"
        :checked="sourceType === 'performance_report'"
        @input="$emit('source-type', $event)"
      >
        {{ translate('scheduler.modal.source.performance.report') }}
      </mds-radio-button>
    </mds-fieldset>
    <mds-fieldset
      v-if="showDataSetType"
      :legend="translate('scheduler.modal.data.set.type.label')"
      class="scheduler-modal__data_set_fieldset"
      variation="radio-group"
      required
    >
      <mds-radio-button
        class="scheduler-modal__data-set-type"
        name="data-set-type-group"
        value="basic"
        :disabled="disableAllDataSetType"
        :checked="dataSetType === 'basic'"
        @input="$emit('source-data-set-type', 'basic')"
      >
        {{ translate('scheduler.modal.source.custom.data.set.basic') }}
      </mds-radio-button>
      <mds-radio-button
        class="scheduler-modal__data-set-type"
        name="data-set-type-group"
        value="holdings"
        :disabled="disableAllDataSetType || disableHoldingsDataSetType"
        :checked="dataSetType === 'holdings'"
        @input="$emit('source-data-set-type', 'holdings')"
      >
        {{ translate('scheduler.modal.source.custom.data.set.holdings') }}
      </mds-radio-button>
    </mds-fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../config/i18n'
import MdsFieldset from '@mds/fieldset'
import MdsRadioButton from '@mds/radio-button'
import { SOURCE_TYPES } from '../config/constants'

export default {
  name: 'SourceStep',
  components: {
    MdsFieldset,
    MdsRadioButton,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    sourceStepInfo: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
    sourceType: {
      type: String,
      default: '',
    },
    dataSetType: {
      type: String,
      default: '',
    },
    holdingsEntitlements: {
      type: Object,
      default: /* istanbul ignore next */ () => ({}),
    },
  },
  data() {
    return {
      defaultConfig,
      types: Object.values(SOURCE_TYPES),
    }
  },
  computed: {
    ...mapState({
      editedFeed: (state) => state.cache.cache.editedFeed,
      cache: (state) => state.cache.cache,
    }),
    userSettings() {
      return this.cache.userSettings
    },
    showPerformanceReporting() {
      return true
      // if (this.userSettings) {
      //   const { data_access_only = true } = this.userSettings
      //   return !data_access_only
      // }
      // return false
    },
    showDataSetType() {
      if (this.sourceType === SOURCE_TYPES.performancereport) {
        return false
      }
      return true
    },
    disableAllDataSetType() {
      if (this.cache.editedFeed) {
        return true
      }
      return false
    },
    disableHoldingsDataSetType() {
      const { packages = [] } = this.holdingsEntitlements
      if (packages.length <= 0) {
        return true
      }
      return false
    },
    disableRadioButtons() {
      if (this.cache.editedFeed) {
        return true
      }
      const { path = '' } = this.$route ?? {}
      const url_paths = path.split('/').filter((path) => !isEmpty(path))

      if (url_paths.indexOf('scheduler') > -1) {
        const { query = {} } = this.$route
        const idType = query.idType
          ? SOURCE_TYPES[query.idType.toLowerCase()]
          : ''
        return this.types.indexOf(idType) > -1
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
.feeds-modal {
  &::v-deep > [class^='mds-modal__wrapper'] {
    max-width: 400px;
  }
}
.scheduler-modal {
  &__source-type ::v-deep,
  &__data-set-type ::v-deep {
    span[class^='mds-radio-button__visible-wrap'] {
      align-items: center;
      margin-bottom: $mds-space-three-quarter-x;
    }
    span[class^='mds-radio-button__visual'] {
      margin-bottom: 0;
      * {
        margin-bottom: 0;
      }
    }
  }
  &__fieldset,
  &__data_set_fieldset {
    margin-top: $mds-space-5-x;
  }
}
</style>
